(function () {
  function initTypewriter(root) {
    if (root.dataset.typewriterInitialized === 'true') return;
    root.dataset.typewriterInitialized = 'true';

    var contentEl = root.querySelector('[data-typewriter-content]');
    var container = root.closest('.announcement-bar') || root.parentElement;
    var sourceList = container ? container.querySelector('[data-typewriter-messages]') : null;
    if (!contentEl || !sourceList) return;

    var messages = Array.prototype.slice
      .call(sourceList.querySelectorAll('li'))
      .map(function (li) {
        return li.textContent.trim();
      })
      .filter(Boolean);

    if (messages.length === 0) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || messages.length === 1) {
      contentEl.textContent = messages[0];
      return;
    }

    var index = 0;
    var charIndex = contentEl.textContent.length;
    var typingSpeed = 65;
    var deletingSpeed = 38;
    var pauseAfterType = 3800;
    var pauseAfterDelete = 500;

    // If the pre-rendered first message differs from our messages[0] (e.g. HTML
    // stripping mismatch), resync before animating.
    if (contentEl.textContent.trim() !== messages[0]) {
      charIndex = 0;
      contentEl.textContent = '';
    }

    function type() {
      var current = messages[index];
      charIndex++;
      contentEl.textContent = current.slice(0, charIndex);
      if (charIndex < current.length) {
        window.setTimeout(type, typingSpeed);
      } else {
        window.setTimeout(deleteText, pauseAfterType);
      }
    }

    function deleteText() {
      var current = messages[index];
      charIndex--;
      contentEl.textContent = current.slice(0, Math.max(charIndex, 0));
      if (charIndex > 0) {
        window.setTimeout(deleteText, deletingSpeed);
      } else {
        index = (index + 1) % messages.length;
        window.setTimeout(type, pauseAfterDelete);
      }
    }

    // Start by pausing on the pre-rendered first message, then deleting into
    // the cycle.
    window.setTimeout(deleteText, pauseAfterType);
  }

  function initAll() {
    document.querySelectorAll('[data-typewriter-text]').forEach(initTypewriter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target.querySelector && event.target.querySelector('[data-typewriter-text]');
    if (root) {
      root.dataset.typewriterInitialized = 'false';
      initTypewriter(root);
    }
  });
})();
